import riskConfig from "@/apps/risk-assessment/app.config"



var configs = [

    riskConfig
];


var registrationConfig = configs.map(e => {
    return {
        store: e.storeModule,
        route: e.route,
    }
});

export default registrationConfig;
